import React from "react";
import { BRAND } from "../../lib/constants";
import { Truck, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#122A1E] text-[#F4F4F1]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-10">
        {/* Huge CTA */}
        <a
          href="#quote"
          className="group block border-y-2 border-[#F4F4F1]/30 py-10 md:py-14 hover:bg-[#0C1D14] transition-colors"
          data-testid="footer-cta-quote"
        >
          <div className="flex items-center justify-between gap-6">
            <div className="font-display font-black uppercase tracking-tighter leading-[0.85] text-[clamp(42px,7vw,112px)]">
              Ready<span className="text-[#FF5A00]">?</span>
              <br />
              Let's Move.
            </div>
            <div className="w-16 h-16 md:w-24 md:h-24 flex-none bg-[#FF5A00] text-white flex items-center justify-center group-hover:rotate-[-12deg] transition-transform">
              <ArrowUpRight size={32} />
            </div>
          </div>
        </a>

        {/* Info grid */}
        <div className="grid md:grid-cols-12 gap-8 mt-14">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-[#FF5A00] text-white flex items-center justify-center">
                <Truck size={18} />
              </div>
              <div>
                <div className="font-display font-black uppercase tracking-tighter text-lg">{BRAND.short}</div>
                <div className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/70">{BRAND.tagline}</div>
              </div>
            </div>
            <p className="mt-5 text-[#F4F4F1]/70 max-w-sm text-sm leading-relaxed">
              Canadian-owned direct carrier for RVs, motorcycles, ATVs, snowmobiles
              and marine vehicles. Door-to-door. Coast-to-coast. Never a broker.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/60 mb-4">Services</div>
            <ul className="space-y-2 text-sm">
              {["RV & Motorhome", "Motorcycle", "ATV & Side-by-Side", "Snowmobile", "Marine & Boat"].map((l) => (
                <li key={l}><a className="hover:text-[#FF5A00]" href="#services">{l}</a></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/60 mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><a className="hover:text-[#FF5A00]" href="#why-us">Why Us</a></li>
              <li><a className="hover:text-[#FF5A00]" href="#coverage">Coverage</a></li>
              <li><a className="hover:text-[#FF5A00]" href="#faq">FAQ</a></li>
              <li><a className="hover:text-[#FF5A00]" href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/60 mb-4">Dispatch</div>
            <ul className="space-y-2 text-sm">
              <li><a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} className="hover:text-[#FF5A00]">{BRAND.phone}</a></li>
              <li><a href={`mailto:${BRAND.email}`} className="hover:text-[#FF5A00] break-all">{BRAND.email}</a></li>
              <li className="text-[#F4F4F1]/70 text-xs">{BRAND.hours}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t-2 border-[#F4F4F1]/20 flex flex-col md:flex-row gap-3 justify-between items-start md:items-center font-mono-accent text-[10px] uppercase text-[#F4F4F1]/60">
          <div>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</div>
          <div>◆ Canadian Direct Carrier · DOT Compliant · Fully Insured</div>
        </div>
      </div>
    </footer>
  );
}
